/** medCloud strings for pa, te, ta, mr, bn, kn (en/hi live in translations.js). */

const mk = (values) => values;

export const MED_CLOUD_LOCALE_BLOCKS = {
  pa: mk({
    title: "ਮੈਡਕਲਾਉਡ",
    subtitle: "ਤੁਹਾਡਾ ਸੁਰੱਖਿਅਤ ਡਿਜਿਟਲ ਸਿਹਤ ਰਿਕਾਰਡ ਵਾਲਟ",
    records: "ਰਿਕਾਰਡ",
    types: "ਕਿਸਮਾਂ",
    storage: "ਸਟੋਰੇਜ",
    upload: "ਅਪਲੋਡ",
    justNow: "ਹੁਣੇ",
    uploading: "ਅਪਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    uploadSuccess: "{name} ਸਫਲਤਾਪੂਰਵਕ ਅਪਲੋਡ ਹੋ ਗਿਆ!",
    uploadFailed: "ਅਪਲੋਡ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    invalidFileTypeWithWord:
      "ਕੇਵਲ ਮੈਡੀਕਲ ਚਿੱਤਰ, PDF, Word ਦਸਤਾਵੇਜ਼ ਜਾਂ ਮੈਡੀਕਲ ਵੀਡੀਓ ਦੀ ਇਜਾਜ਼ਤ ਹੈ।",
    analyzingFile: "{name} ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ...",
    uploadAnalyzedSuccess: "{name} ਸਫਲਤਾਪੂਰਵਕ ਅਪਲੋਡ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਿਤ ਹੋ ਗਿਆ!",
    uploadHealthRecord: "ਸਿਹਤ ਰਿਕਾਰਡ ਅਪਲੋਡ ਕਰੋ",
    chooseHowToAdd: "ਦਸਤਾਵੇਜ਼ ਜੋੜਨ ਦਾ ਤਰੀਕਾ ਚੁਣੋ",
    analyzingDocument: "ਦਸਤਾਵੇਜ਼ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ...",
    browseFiles: "ਫਾਈਲਾਂ ਬ੍ਰਾਊਜ਼ ਕਰੋ",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "ਫੋਟੋ ਲਓ",
    takePhotoDesc: "ਦਸਤਾਵੇਜ਼ ਜਾਂ ਪਰਚੀ ਦੀ ਫੋਟੋ ਲਓ",
    cameraNotFound: "ਕੈਮਰਾ ਨਹੀਂ ਮਿਲਿਆ",
    closeUploadDrawer: "ਅਪਲੋਡ ਡਰਾਅਰ ਬੰਦ ਕਰੋ",
    remainingOf: "ਵਿੱਚੋਂ ਬਾਕੀ",
    deleteConfirmTitle: "ਇਹ ਰਿਕਾਰਡ ਮਿਟਾਉਣਾ ਹੈ?",
    emptyVault: "ਅਜੇ ਕੋਈ ਸਿਹਤ ਰਿਕਾਰਡ ਨਹੀਂ। ਆਪਣੀ ਪਹਿਲੀ ਫਾਈਲ ਅਪਲੋਡ ਕਰੋ।",
    emptyFilter: "ਇਸ ਸ਼੍ਰੇਣੀ ਵਿੱਚ ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ ਮਿਲਿਆ।",
    deleteSuccess: "ਫਾਈਲ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾਈ ਗਈ",
    deleteFailed: "ਫਾਈਲ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  }),
  te: mk({
    title: "మెడ్‌క్లౌడ్",
    subtitle: "మీ సురక్షిత డిజిటల్ ఆరోగ్య రికార్డ్ వాల్ట్",
    records: "రికార్డులు",
    types: "రకాలు",
    storage: "స్టోరేజ్",
    upload: "అప్‌లోడ్",
    justNow: "ఇప్పుడే",
    uploading: "అప్‌లోడ్ అవుతోంది...",
    uploadSuccess: "{name} విజయవంతంగా అప్‌లోడ్ అయింది!",
    uploadFailed: "అప్‌లోడ్ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    invalidFileTypeWithWord:
      "మెడికల్ చిత్రాలు, PDF, Word పత్రాలు లేదా మెడికల్ వీడియోలు మాత్రమే అనుమతించబడతాయి.",
    analyzingFile: "{name} విశ్లేషిస్తోంది...",
    uploadAnalyzedSuccess: "{name} విజయవంతంగా అప్‌లోడ్ మరియు విశ్లేషించబడింది!",
    uploadHealthRecord: "ఆరోగ్య రికార్డ్ అప్‌లోడ్ చేయండి",
    chooseHowToAdd: "మీ పత్రాన్ని జోడించే విధానాన్ని ఎంచుకోండి",
    analyzingDocument: "పత్రం విశ్లేషిస్తోంది...",
    browseFiles: "ఫైళ్లను బ్రౌజ్ చేయండి",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "ఫోటో తీయండి",
    takePhotoDesc: "పత్రం లేదా ప్రిస్క్రిప్షన్ క్యాప్చర్ చేయండి",
    cameraNotFound: "మీ కెమెరా కనుగొనబడలేదు",
    closeUploadDrawer: "అప్‌లోడ్ డ్రాయర్ మూసివేయండి",
    remainingOf: "లో మిగిలిన",
    deleteConfirmTitle: "ఈ రికార్డ్ తొలగించాలా?",
    emptyVault: "ఇంకా ఆరోగ్య రికార్డులు లేవు. మీ మొదటి ఫైల్ అప్‌లోడ్ చేయండి.",
    emptyFilter: "ఈ వర్గంలో రికార్డులు కనుగొనబడలేదు.",
    deleteSuccess: "ఫైల్ విజయవంతంగా తొలగించబడింది",
    deleteFailed: "ఫైల్ తొలగించడం విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
  }),
  ta: mk({
    title: "மெட்கிளவுட்",
    subtitle: "உங்கள் பாதுகாப்பான டிஜிட்டல் சுகாதார பதிவு பெட்டகம்",
    records: "பதிவுகள்",
    types: "வகைகள்",
    storage: "சேமிப்பு",
    upload: "பதிவேற்றம்",
    justNow: "இப்போது",
    uploading: "பதிவேற்றுகிறது...",
    uploadSuccess: "{name} வெற்றிகரமாக பதிவேற்றப்பட்டது!",
    uploadFailed: "பதிவேற்றம் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    invalidFileTypeWithWord:
      "மருத்துவ படங்கள், PDF, Word ஆவணங்கள் அல்லது மருத்துவ வீடியோக்கள் மட்டுமே அனுமதிக்கப்படும்.",
    analyzingFile: "{name} பகுப்பாய்வு செய்யப்படுகிறது...",
    uploadAnalyzedSuccess: "{name} வெற்றிகரமாக பதிவேற்றப்பட்டு பகுப்பாய்வு செய்யப்பட்டது!",
    uploadHealthRecord: "சுகாதார பதிவை பதிவேற்றவும்",
    chooseHowToAdd: "உங்கள் ஆவணத்தைச் சேர்க்கும் வழியைத் தேர்ந்தெடுக்கவும்",
    analyzingDocument: "ஆவணம் பகுப்பாய்வு செய்யப்படுகிறது...",
    browseFiles: "கோப்புகளை உலாவு",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "புகைப்படம் எடு",
    takePhotoDesc: "ஆவணம் அல்லது மருந்துச்சீட்டை பிடிக்கவும்",
    cameraNotFound: "உங்கள் கேமரா கிடைக்கவில்லை",
    closeUploadDrawer: "பதிவேற்ற டிராயரை மூடு",
    remainingOf: "இல் மீதமுள்ள",
    deleteConfirmTitle: "இந்த பதிவை நீக்கவா?",
    emptyVault: "இன்னும் சுகாதார பதிவுகள் இல்லை. உங்கள் முதல் கோப்பை பதிவேற்றவும்.",
    emptyFilter: "இந்த வகையில் பதிவுகள் இல்லை.",
    deleteSuccess: "கோப்பு வெற்றிகரமாக நீக்கப்பட்டது",
    deleteFailed: "கோப்பை நீக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  }),
  mr: mk({
    title: "मेडक्लाउड",
    subtitle: "तुमचा सुरक्षित डिजिटल आरोग्य रेकॉर्ड व्हॉल्ट",
    records: "रेकॉर्ड",
    types: "प्रकार",
    storage: "स्टोरेज",
    upload: "अपलोड",
    justNow: "आत्ताच",
    uploading: "अपलोड होत आहे...",
    uploadSuccess: "{name} यशस्वीरित्या अपलोड झाले!",
    uploadFailed: "अपलोड अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    invalidFileTypeWithWord:
      "फक्त वैद्यकीय प्रतिमा, PDF, Word दस्तऐवज किंवा वैद्यकीय व्हिडिओ परवानगी आहेत.",
    analyzingFile: "{name} चे विश्लेषण होत आहे...",
    uploadAnalyzedSuccess: "{name} यशस्वीरित्या अपलोड आणि विश्लेषित झाले!",
    uploadHealthRecord: "आरोग्य रेकॉर्ड अपलोड करा",
    chooseHowToAdd: "दस्तऐवज जोडण्याची पद्धत निवडा",
    analyzingDocument: "दस्तऐवजाचे विश्लेषण होत आहे...",
    browseFiles: "फाइल ब्राउझ करा",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "फोटो घ्या",
    takePhotoDesc: "दस्तऐवज किंवा प्रिस्क्रिप्शन कॅप्चर करा",
    cameraNotFound: "कॅमेरा सापडला नाही",
    closeUploadDrawer: "अपलोड ड्रॉअर बंद करा",
    remainingOf: "पैकी शिल्लक",
    deleteConfirmTitle: "हा रेकॉर्ड हटवायचा?",
    emptyVault: "अद्याप आरोग्य रेकॉर्ड नाहीत. पहिली फाइल अपलोड करा.",
    emptyFilter: "या श्रेणीत रेकॉर्ड सापडले नाहीत.",
    deleteSuccess: "फाइल यशस्वीरित्या हटवली",
    deleteFailed: "फाइल हटवण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
  }),
  bn: mk({
    title: "মেডক্লাউড",
    subtitle: "আপনার নিরাপদ ডিজিটাল স্বাস্থ্য রেকর্ড ভল্ট",
    records: "রেকর্ড",
    types: "ধরন",
    storage: "স্টোরেজ",
    upload: "আপলোড",
    justNow: "এইমাত্র",
    uploading: "আপলোড হচ্ছে...",
    uploadSuccess: "{name} সফলভাবে আপলোড হয়েছে!",
    uploadFailed: "আপলোড ব্যর্থ। আবার চেষ্টা করুন।",
    invalidFileTypeWithWord:
      "শুধুমাত্র মেডিকেল ছবি, PDF, Word নথি বা মেডিকেল ভিডিও অনুমোদিত।",
    analyzingFile: "{name} বিশ্লেষণ করা হচ্ছে...",
    uploadAnalyzedSuccess: "{name} সফলভাবে আপলোড ও বিশ্লেষণ হয়েছে!",
    uploadHealthRecord: "স্বাস্থ্য রেকর্ড আপলোড করুন",
    chooseHowToAdd: "নথি যোগ করার উপায় বেছে নিন",
    analyzingDocument: "নথি বিশ্লেষণ করা হচ্ছে...",
    browseFiles: "ফাইল ব্রাউজ করুন",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "ছবি তুলুন",
    takePhotoDesc: "নথি বা প্রেসক্রিপশন ক্যাপচার করুন",
    cameraNotFound: "ক্যামেরা পাওয়া যায়নি",
    closeUploadDrawer: "আপলোড ড্রয়ার বন্ধ করুন",
    remainingOf: "এর মধ্যে অবশিষ্ট",
    deleteConfirmTitle: "এই রেকর্ড মুছবেন?",
    emptyVault: "এখনও স্বাস্থ্য রেকর্ড নেই। প্রথম ফাইল আপলোড করুন।",
    emptyFilter: "এই বিভাগে কোনো রেকর্ড পাওয়া যায়নি।",
    deleteSuccess: "ফাইল সফলভাবে মুছে ফেলা হয়েছে",
    deleteFailed: "ফাইল মুছতে ব্যর্থ। আবার চেষ্টা করুন।",
  }),
  kn: mk({
    title: "ಮೆಡ್‌ಕ್ಲೌಡ್",
    subtitle: "ನಿಮ್ಮ ಸುರಕ್ಷಿತ ಡಿಜಿಟಲ್ ಆರೋಗ್ಯ ದಾಖಲೆ ವಾಲ್ಟ್",
    records: "ದಾಖಲೆಗಳು",
    types: "ಪ್ರಕಾರಗಳು",
    storage: "ಸಂಗ್ರಹಣೆ",
    upload: "ಅಪ್‌ಲೋಡ್",
    justNow: "ಈಗಷ್ಟೇ",
    uploading: "ಅಪ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    uploadSuccess: "{name} ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಆಗಿದೆ!",
    uploadFailed: "ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    invalidFileTypeWithWord:
      "ವೈದ್ಯಕೀಯ ಚಿತ್ರಗಳು, PDF, Word ದಾಖಲೆಗಳು ಅಥವಾ ವೈದ್ಯಕೀಯ ವೀಡಿಯೊಗಳು ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ.",
    analyzingFile: "{name} ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
    uploadAnalyzedSuccess: "{name} ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಮತ್ತು ವಿಶ್ಲೇಷಿಸಲಾಗಿದೆ!",
    uploadHealthRecord: "ಆರೋಗ್ಯ ದಾಖಲೆ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    chooseHowToAdd: "ನಿಮ್ಮ ದಾಖಲೆಯನ್ನು ಸೇರಿಸುವ ವಿಧಾನವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    analyzingDocument: "ದಾಖಲೆಯನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
    browseFiles: "ಫೈಲ್‌ಗಳನ್ನು ಬ್ರೌಸ್ ಮಾಡಿ",
    browseFilesDesc: "PDF, Word, Images, Videos",
    takePhoto: "ಫೋಟೋ ತೆಗೆಯಿರಿ",
    takePhotoDesc: "ದಾಖಲೆ ಅಥವಾ ಪ್ರಿಸ್ಕ್ರಿಪ್ಶನ್ ಸೆರೆಹಿಡಿಯಿರಿ",
    cameraNotFound: "ನಿಮ್ಮ ಕ್ಯಾಮೆರಾ ಕಂಡುಬಂದಿಲ್ಲ",
    closeUploadDrawer: "ಅಪ್‌ಲೋಡ್ ಡ್ರಾಯರ್ ಮುಚ್ಚಿ",
    remainingOf: "ನಲ್ಲಿ ಉಳಿದಿದೆ",
    deleteConfirmTitle: "ಈ ದಾಖಲೆಯನ್ನು ಅಳಿಸುವುದೇ?",
    emptyVault: "ಇನ್ನೂ ಆರೋಗ್ಯ ದಾಖಲೆಗಳಿಲ್ಲ. ನಿಮ್ಮ ಮೊದಲ ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
    emptyFilter: "ಈ ವರ್ಗದಲ್ಲಿ ದಾಖಲೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    deleteSuccess: "ಫೈಲ್ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
    deleteFailed: "ಫೈಲ್ ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  }),
};

export const applyMedCloudLocaleBlocks = (translations) => {
  Object.entries(MED_CLOUD_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].medCloud = {
      ...translations[lang].medCloud,
      ...values,
    };
  });
};
